var _defs, _path, _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirclePlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_8396",
    width: 38.144,
    height: 38.144,
    viewBox: "0 0 38.144 38.144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:currentColor}.cls-2{fill:#fff}\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    d: "M13.486 0A13.486 13.486 0 1 1 0 13.486 13.486 13.486 0 0 1 13.486 0z",
    className: "cls-1",
    transform: "rotate(-45 23.022 9.536)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    cx: 12.137,
    cy: 12.137,
    r: 12.137,
    className: "cls-2",
    transform: "rotate(-45 23.975 7.234)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    cx: 10.114,
    cy: 10.114,
    r: 10.114,
    className: "cls-1",
    transform: "rotate(-45 25.406 3.78)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8162",
    transform: "translate(14.015 14.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7283",
    d: "M0 0H1.349V10.114H0z",
    className: "cls-2",
    transform: "rotate(90 2.865 7.249)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7284",
    d: "M0 0H1.349V10.114H0z",
    className: "cls-2",
    transform: "rotate(180 2.865 5.057)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlus);
export default __webpack_public_path__ + "static/media/circle_plus.41eaac91e2b9f7597c03aa4f2624f718.svg";
export { ForwardRef as ReactComponent };